import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { IProductTypeListMode, ngHelper, UiContextService } from '@cakeiteasy/web-utils';

import { ICakeCartLine } from '../../../cart';
import {
  getCartLinesByParentTypeId,
  getChosenMenu,
  isModalClickIgnored
} from '../../helpers';

@Component({
  standalone: false,
  selector: 'catering-menu-type',
  templateUrl: './catering-menu-type.component.html',
  styleUrls: ['./catering-menu-type.component.scss']
})
export class CateringMenuTypeComponent implements OnChanges {
  @Input() productType: IProductTypeListMode;
  @Input() cartLines: ICakeCartLine[];
  @Input() showImage: boolean;

  @Output() showModal = new EventEmitter<{
    productType: IProductTypeListMode;
    orderLineBuilderId?: string;
    isEdit?: boolean;
  }>();
  @Output() showCart = new EventEmitter<void>();

  public currentLines: ICakeCartLine[];
  public menuBuilds: { line: ICakeCartLine; fullPrice: number; products: ReturnType<typeof getChosenMenu> }[] = [];

  constructor(public uiContext: UiContextService) { }

  public get buildsCount(): number {
    return this.menuBuilds.length;
  }

  private _setLines(cartLines: ICakeCartLine[]) {
    this.currentLines = getCartLinesByParentTypeId(this.productType.id, cartLines || []);
    const groups = new Map<string, ICakeCartLine[]>();
    this.currentLines.forEach(line => {
      if (!line.orderLineBuilderId) {
        return;
      }
      const lines = groups.get(line.orderLineBuilderId) || [];
      lines.push(line);
      groups.set(line.orderLineBuilderId, lines);
    });
    this.menuBuilds = Array.from(groups.values()).map(lines => ({
      line: lines[0],
      fullPrice: lines.reduce((total, line) => total + line.fullPrice, 0),
      products: getChosenMenu(lines),
    }));
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'cartLines', (cartLines: ICakeCartLine[]) => {
      this._setLines(cartLines);
    });
  }

  public onShowModal(line?: ICakeCartLine) {
    this.showModal.emit({
      productType: this.productType,
      orderLineBuilderId: line?.orderLineBuilderId,
      isEdit: !!line?.orderLineBuilderId,
    });
  }

  public onEdit() {
    const [build] = this.menuBuilds;
    this.onShowModal(build?.line);
  }

  public onShowCart() {
    this.showCart.emit();
  }

  public onProductTypeClick(event: MouseEvent) {
    if (isModalClickIgnored(event)) {
      return;
    }

    this.onShowModal();
  }
}
